'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'industry';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f275';
var svgPathData = 'M0 88C0 57.1 25.1 32 56 32l48 0c30.9 0 56 25.1 56 56l0 84.9 103.8-60.6c32-18.7 72.2 4.4 72.2 41.5l0 27 102.1-65.4C470.1 95 512 117.9 512 155.9L512 416c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 88zm56-8c-4.4 0-8 3.6-8 8l0 328c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-260.1-139.1 89c-7.4 4.7-16.8 5-24.5 .8S288 233.4 288 224.6l0-70.9-139.9 81.6c-7.4 4.3-16.6 4.4-24 .1s-12-12.2-12-20.8L112 88c0-4.4-3.6-8-8-8L56 80z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faIndustry = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;